/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import * as Sentry from '@sentry/angular';

function getHttpFailureNoiseReason(error: unknown, event: Sentry.ErrorEvent): string | null {
	const candidates: unknown[] = [error];
	if (error && typeof error === 'object' && 'originalError' in error) {
		candidates.push((error as {originalError?: unknown}).originalError);
	}
	if (event.extra?.['__serialized__']) {
		candidates.push(event.extra['__serialized__']);
	}

	for (const candidate of candidates) {
		if (!candidate || typeof candidate !== 'object') {
			continue;
		}
		const status = 'status' in candidate ? Number((candidate as {status?: unknown}).status) : NaN;
		const url = 'url' in candidate && typeof (candidate as {url?: unknown}).url === 'string'
			? (candidate as {url: string}).url
			: '';
		if (status === 0 || status === 401) {
			return `http-status-${status}`;
		}
		if (status === 404 && url.includes('restaurant_table_map/assignment/')) {
			return 'http-404-table-assignment';
		}
	}

	const message =
		(typeof error === 'object' && error && 'message' in error && typeof (error as {message?: unknown}).message === 'string'
			? (error as {message: string}).message
			: null)
		?? event.exception?.values?.[0]?.value
		?? (typeof event.message === 'string' ? event.message : null);

	if (typeof message === 'string' && message.includes('Http failure response')) {
		if (/:\s*0\b/.test(message) || /:\s*401\b/.test(message)) {
			return 'http-failure-message';
		}
		if (message.includes('restaurant_table_map/assignment/') && /:\s*404\b/.test(message)) {
			return 'http-404-table-assignment';
		}
		if (message.includes('/assets/version.json')) {
			return 'version-json';
		}
	}

	return null;
}

Sentry.init({
	dsn: "https://b1012e15e4d71b63354a8bf5ae147d86@o123270.ingest.us.sentry.io/4511722779639808",
	dataCollection: {
		// To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
		// https://docs.sentry.io/platforms/javascript/guides/angular/configuration/options/#dataCollection
		// userInfo: false,
		// httpBodies: []
	},
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration()
	],
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ["localhost", /^https:\/\/api\.groin.le17-45.fr/],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
	// Enable sending logs to Sentry
	enableLogs: true,
	beforeSend(event, hint) {
		if (getHttpFailureNoiseReason(hint.originalException ?? hint.syntheticException, event)) {
			return null;
		}
		return event;
	},
});
if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));
